import React from 'react'
import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

export default function Divider({full = false, className}: {full?: boolean; className?: string}) {
  const isDarkMode = useIsDarkMode()
  return (
    <div className={classnames({'bg-white': !isDarkMode, 'bg-zinc-800': isDarkMode})}>
      <div
        className={classnames({
          'p-1 md:p-2 border-b ': true,
          'border-b-gray-200': !isDarkMode,
          'border-b-zinc-700': isDarkMode,
          'ml-4 mr-4': !full,
          [className]: !!className
        })}></div>
    </div>
  )
}
